import { select } from '@ps/web-core-store';
import { mapValues } from 'lodash';
import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Trackers as AnalyticsTrackers } from '../../../';
import type { TrackingContextValue } from '../../providers/TrackingContext';
import { TrackingContext } from '../../providers/TrackingContext';

type OmitContext<T> = T extends (tracking: TrackingContextValue, ...args: infer R) => void
  ? (...args: R) => void
  : never;

type Trackers = typeof AnalyticsTrackers;

export type BoundTrackers = {
  [key in keyof Trackers]: OmitContext<Trackers[key]>;
};

const useTrackers = () => {
  const trackingContext = useContext(TrackingContext);
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);

  return useMemo(
    () =>
      mapValues(
        AnalyticsTrackers,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (tracker: any): OmitContext<typeof tracker> =>
          (...args) =>
            tracker({ ...trackingContext, isMobileEmbedded }, ...args)
      ) as BoundTrackers,
    [isMobileEmbedded, trackingContext]
  );
};

export default useTrackers;
